module.exports = __webpack_public_path__ + "static/m-db40ed7db4cdc9e6c6f7a013f1a29cf6.ico";